import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            minHeight: '100%',
            maxHeight: '100%'
        },
        dashboardArea: {
            flex: '1 1 0',
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        },
        footer: {
            position: 'relative',
            flexShrink: 0
        }
    }
})